/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const dashboardCategoryEnum = {
  activities: 'activities',
  change_tracker: 'change_tracker',
  channels: 'channels',
  issue_tracker: 'issue_tracker',
  shift_manager: 'shift_manager',
  custom: 'custom',
} as const;

export type DashboardCategoryEnumSchemaKey = (typeof dashboardCategoryEnum)[keyof typeof dashboardCategoryEnum];

export type DashboardSchema = {
  /**
   * @type string
   */
  category: DashboardCategoryEnumSchemaKey;
  /**
   * @type string
   */
  description: string;
  /**
   * @type string, uuid
   */
  id: string;
  /**
   * @type boolean
   */
  pro: boolean;
  /**
   * @type integer
   */
  sortPosition: number;
  /**
   * @type string, uuid
   */
  teamId: string | null;
  /**
   * @type string
   */
  title: string;
};
